/**
 * Alpha Stamp SVG Component
 * Red rubber stamp style badge indicating alpha status
 */
import React from 'react';
import { Tooltip } from '@mui/material';

function AlphaStamp({ size = 40 }) {
  const aspectRatio = 1.8; // width to height ratio
  const width = size * aspectRatio;
  const height = size;

  return (
    <Tooltip
      title="This is an alpha release. Features may change and data may have errors."
      arrow
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 90 50"
        style={{
          marginLeft: 8,
          transform: 'rotate(-5deg)',
          cursor: 'help'
        }}
      >
        {/* Distressed texture filter */}
        <defs>
          <filter id="distress" x="-10%" y="-10%" width="120%" height="120%">
            <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" result="noise"/>
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" xChannelSelector="R" yChannelSelector="G"/>
          </filter>
          <mask id="speckle">
            <rect width="100%" height="100%" fill="white"/>
            <circle cx="15" cy="12" r="1.5" fill="black"/>
            <circle cx="25" cy="8" r="1" fill="black"/>
            <circle cx="45" cy="10" r="1.2" fill="black"/>
            <circle cx="60" cy="7" r="1" fill="black"/>
            <circle cx="75" cy="12" r="1.3" fill="black"/>
            <circle cx="12" cy="25" r="1" fill="black"/>
            <circle cx="35" cy="22" r="0.8" fill="black"/>
            <circle cx="55" cy="28" r="1.1" fill="black"/>
            <circle cx="78" cy="25" r="1" fill="black"/>
            <circle cx="18" cy="38" r="1.2" fill="black"/>
            <circle cx="40" cy="42" r="1" fill="black"/>
            <circle cx="62" cy="40" r="0.9" fill="black"/>
            <circle cx="72" cy="38" r="1.1" fill="black"/>
            <circle cx="8" cy="30" r="0.8" fill="black"/>
            <circle cx="82" cy="32" r="1" fill="black"/>
            <circle cx="30" cy="35" r="0.7" fill="black"/>
            <circle cx="50" cy="15" r="1" fill="black"/>
            <circle cx="20" cy="18" r="0.9" fill="black"/>
            <circle cx="68" cy="20" r="1.2" fill="black"/>
          </mask>
        </defs>

        {/* Main stamp group with mask for speckle effect */}
        <g mask="url(#speckle)">
          {/* ALPHA text */}
          <text
            x="45"
            y="32"
            textAnchor="middle"
            fontFamily="'Arial Black', 'Helvetica Neue', Arial, sans-serif"
            fontSize="22"
            fontWeight="900"
            fill="#c41e3a"
            letterSpacing="2"
          >
            ALPHA
          </text>
        </g>
      </svg>
    </Tooltip>
  );
}

export default AlphaStamp;
